import type { IconOption } from '@/components/IconPicker'

// Curated set offered by the Subscription icon picker. Every `name` must be a valid
// lucide-react dynamic icon name (see categoryIcon.tsx) — generic, recognizable glyphs
// (a film clapper for "streaming"), not brand logos, matching how Account/Category icons
// already work here.
export const SUBSCRIPTION_ICON_OPTIONS: IconOption[] = [
  { name: 'clapperboard', label: 'Streaming / OTT' },
  { name: 'music', label: 'Music' },
  { name: 'cloud', label: 'Cloud Storage' },
  { name: 'newspaper', label: 'News / Magazines' },
  { name: 'dumbbell', label: 'Gym / Fitness' },
  { name: 'gamepad-2', label: 'Gaming' },
  { name: 'laptop', label: 'Software / Productivity' },
  { name: 'graduation-cap', label: 'Courses / Learning' },
  { name: 'sparkles', label: 'Membership' },
  { name: 'repeat', label: 'Other' },
]

export const DEFAULT_SUBSCRIPTION_ICON = 'repeat'

// Quick-add templates shown when Kind = Subscription — tapping one pre-fills name + icon.
export const SUBSCRIPTION_TEMPLATES: { name: string; icon: string }[] = [
  { name: 'Netflix', icon: 'clapperboard' },
  { name: 'Amazon Prime Video', icon: 'clapperboard' },
  { name: 'Disney+ Hotstar', icon: 'clapperboard' },
  { name: 'Spotify', icon: 'music' },
  { name: 'YouTube Premium', icon: 'clapperboard' },
  { name: 'Apple Music', icon: 'music' },
  { name: 'JioCinema', icon: 'clapperboard' },
  { name: 'Google One', icon: 'cloud' },
  { name: 'iCloud+', icon: 'cloud' },
  { name: 'Gym Membership', icon: 'dumbbell' },
]
